import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortalHomeComponent } from './home/portal-home.component';
import { PortalQuoteComponent } from './quote/portal-quote.component';
import { PortalPolicyComponent } from './policy/portal-policy.component';
import { PortalOfferNewComponent } from './offer/new/portal-offer-new.component';
import { PortalOfferComponent } from './offer/portal-offer.component';
import { PortalPaymentComponent } from './payment/portal-payment.component';
import { PortalLoginComponent } from './login/portal-login.component';
import { PortalRegisterComponent } from './register/portal-register.component';
import { AuthGuard } from '../auth/auth.guard';
import { PortalAuthGuard } from './portal-auth.guard';
import { PortalPasswordComponent } from './password/portal-password.component';


const routes: Routes = [
    {
        path: 'Portal/Offer',
        component: PortalOfferComponent,
        canActivate: [PortalAuthGuard]
    },
    {
        path: 'Portal/Offer/New',
        component: PortalOfferNewComponent,
        canActivate: [PortalAuthGuard]
    },
    {
        path: 'Portal/Quote',
        component: PortalQuoteComponent,
        canActivate: [PortalAuthGuard]
    },
    {
        path: 'Portal/Policy',
        component: PortalPolicyComponent,
        canActivate: [PortalAuthGuard]
    },
    {
        path: 'Portal/Payment',
        
        component: PortalPaymentComponent,
        canActivate: [PortalAuthGuard]
    },
    {
        path: 'Portal/Home',
        component: PortalHomeComponent,
        canActivate: [PortalAuthGuard]
    },
    {
        path: 'Portal/Login',
        component: PortalLoginComponent
    },
    {
        path: 'Portal/Register',
        component: PortalRegisterComponent
    },
    {
        path: 'Portal/Password',
        component: PortalPasswordComponent
    },
    {
        path: '',
        component: PortalHomeComponent,
        canActivate: [PortalAuthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PortalRoutingModule { }
